import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const ReturnIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path fill="currentColor" d="M10 7v2h8v5H7.99v-3L4 15l3.99 4v-3H19a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z" />
  </BaseIcon>
)
